import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }

  /**
   * Shows a success notification.
   * @param message The main message to display.
   * @param title The title of the notification (optional).
   */
  showSuccess(message: string, title: string = '¡Éxito!') {
    Swal.fire({
      icon: 'success',
      title: title,
      text: message,
      confirmButtonColor: '#3085d6'
    });
  }

  /**
   * Shows an error notification.
   * @param message The main message to display.
   * @param title The title of the notification (optional).
   */
  showError(message: string, title: string = 'Error') {
    Swal.fire({
      icon: 'error',
      title: title,
      text: message,
      confirmButtonColor: '#d33'
    });
  }

  /**
   * Shows an informational notification.
   * @param message The main message to display.
   * @param title The title of the notification (optional).
   */
  showInfo(message: string, title: string = 'Información') {
    Swal.fire({
      icon: 'info',
      title: title,
      text: message,
      confirmButtonColor: '#3085d6'
    });
  }

  /**
   * Shows a confirmation dialog.
   * @param message The question to ask the user.
   * @param title The title of the dialog (optional).
   * @returns A promise that resolves to `true` if confirmed, `false` otherwise.
   */
  showConfirm(message: string, title: string = '¿Estás seguro?'): Promise<boolean> {
    return Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      return result.isConfirmed;
    });
  }
}
